import { itemsOnPage } from "../assets/const";
import {
  SET_GROUPS_DATA,
  SET_GROUPS_LOADING,
  SET_GROUP_CURATORS,
  SET_GROUP_HISTORY,
  SET_GROUP_INFO,
  SET_GROUP_TEAM,
  SET_GROUP_TEAM_FOR_FILTER_CLASS,
  SET_GROUPS_MODAL_LOADING,
  SET_CLASSING_PAGE,
  SET_CLASSING_COUNT,
  SET_GROUP_POSITION_HISTORY,
  SET_GROUP_CURATOR_CANDIDATES,
} from "./types";
import { createNotification } from "../components/Notifications/Notifications";
import { api } from "../App";


export const setPage = (pageNumber) => (
  { type: SET_CLASSING_PAGE, payload: { pageNumber } })

export const getGroups = (sort) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_LOADING, payload: true });
  try {
    const { pageNumber } = getState().groups
    const max_results = itemsOnPage
    const paginate_from = itemsOnPage * pageNumber
    const urlParams = new URLSearchParams({ max_results, paginate_from, sort }).toString();
    const { data } = await api.get(`/groups?${sort ? urlParams : ''}`);
    const { count, groups } = data;//count общее кол-во эл
    const pageCount = Math.ceil(count / itemsOnPage)//pageCount число страниц
    dispatch({ type: SET_GROUPS_DATA, payload: groups });
    dispatch({ type: SET_CLASSING_COUNT, payload: { pageCount, count } });
  } catch (error) {
  } finally {
    dispatch({ type: SET_GROUPS_LOADING, payload: false });
  }
};

export const getGroupInfo = (groupId) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: true });
  try {
    const { data } = await api.get(`/groups/${groupId}`);
    dispatch({ type: SET_GROUP_INFO, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: false });
  }
};

export const getGroupHistory = (groupId) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: true });
  try {
    const { data } = await api.get(`/group_history/${groupId}`);
    dispatch({ type: SET_GROUP_HISTORY, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: false });
  }
};

export const getGroupTeam = (groupId) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: true });
  try {
    const { data } = await api.get(`/groups/${groupId}/listeners`);
    dispatch({ type: SET_GROUP_TEAM, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: false });
  }
};
// для фильтра класс в Составе
export const getGroupTeamForFilterClass = (xp_key, year) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: true });
  try {
    const { data } = await api.get(`/group_history/parallel/${xp_key}/${year}`);
    dispatch({ type: SET_GROUP_TEAM_FOR_FILTER_CLASS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: false });
  }
};
export const createGroupTeamTranfer = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_LOADING, payload: true });
  try {
    await api.post(`/student_transfer`, data);
    createNotification('success', 'Успешно');
    await dispatch(getGroups());
    return { success: true };
  } catch (error) {
    const msg = error.response?.data?.error || 'Ошибка при выполнении движения';
    createNotification('error', msg);
    return { success: false };
  } finally {
    dispatch({ type: SET_GROUPS_LOADING, payload: false });
  }
};

export const getGroupCurators = (groupId) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: true });
  try {
    const { data } = await api.get(`/groups/${groupId}/tutors`);
    dispatch({ type: SET_GROUP_CURATORS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: false });
  }
};

export const updateGroups = (groupId, data) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_LOADING, payload: true });
  try {
    const { data: resp } = await api.put(`/groups/${groupId}`, data);
    if (resp.warning) {
      createNotification('warning', resp.warning);
    } else {
      createNotification('success', 'Изменения сохранены');
    }
    if (resp.curator_candidates?.length) {
      dispatch({ type: SET_GROUP_CURATOR_CANDIDATES, payload: resp.curator_candidates });
    }
    dispatch({ type: SET_CLASSING_PAGE, payload: { pageNumber: 0 } });
    await dispatch(getGroups());
    return resp;
  } catch (error) {
    const msg = error.response?.data?.error || 'Ошибка сохранения';
    createNotification('error', msg);
    return null;
  } finally {
    dispatch({ type: SET_GROUPS_LOADING, payload: false });
  }
};

export const createGroups = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_LOADING, payload: true });
  try {
    const { data: resp } = await api.post(`/groups`, data);
    if (resp.warning) {
      createNotification('warning', resp.warning);
    } else {
      createNotification('success', 'Класс успешно создан');
    }
    if (resp.curator_candidates?.length) {
      dispatch({ type: SET_GROUP_CURATOR_CANDIDATES, payload: resp.curator_candidates });
    }
    dispatch({ type: SET_CLASSING_PAGE, payload: { pageNumber: 0 } });
    await dispatch(getGroups());
    return resp;
  } catch (error) {
    const msg = error.response?.data?.error || 'Ошибка создания';
    createNotification('error', msg);
    return null;
  } finally {
    dispatch({ type: SET_GROUPS_LOADING, payload: false });
  }
};

export const createHistoryGroups = (groupId, data) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: true });
  try {
    await api.post(`/group_history`, data);
    await dispatch(getGroupHistory(groupId));
  } catch (error) {
    createNotification('error', error.response?.data?.error || 'Ошибка')
  } finally {
    dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: false });
  }
};

export const updateHistoryGroups = (groupId, xp_key, values) => async (dispatch, getState) => {
  dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: true });
  try {
    await api.put(`/group_history/${xp_key}`, values);
    await dispatch(getGroupHistory(groupId));
  } catch (error) {
  } finally {
    dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: false });
  }
};

export const deleteHistoryGroups = (confirmation) => async (dispatch, getState) => {
  const { xp_key, classId } = confirmation
  try {
    await api.delete(`/group_history/${xp_key}`);
    await dispatch(getGroupHistory(classId));
    createNotification('success', 'Успешно удалено');
  } catch (error) {
  }
};

export const getPositionHistory = (groupId, pos) => async (dispatch) => {
  dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: true });
  try {
    const { data } = await api.get(`/groups/${groupId}/position_history/${pos}`);
    dispatch({ type: SET_GROUP_POSITION_HISTORY, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_GROUPS_MODAL_LOADING, payload: false });
  }
};

export const markCurator = (groupId, mid) => async (dispatch) => {
  try {
    await api.post(`/groups/${groupId}/mark_curator`, { mid });
    await dispatch(getGroupCurators(groupId));
    dispatch({ type: SET_GROUP_CURATOR_CANDIDATES, payload: null });
    createNotification('success', 'Куратор отмечен в учебной структуре');
  } catch (error) {
    createNotification('error', 'Ошибка при отметке куратора');
  }
};

// export const createGroups = (data) => async (dispatch, getState) => {
//   await dispatch(checkAndUpdateToken());
//   if (getState().auth.token) {
//     dispatch({ type: SET_COURSES_LOADING, payload: true });
//     const response = await fetch(`${API_BASE_URL}/groups`, {
//       method: "POST",
//       body: JSON.stringify(data),
//       ...buildDefaultHeaders(getState),
//     });
//     if (response.ok) {
//       await dispatch(getCoursesList());
//     } else {
//       createNotification('error', 'Ошибка')
//     }
//   }
//   dispatch({ type: SET_COURSES_LOADING, payload: false });
// };